import { Component, ComponentChildren, h } from 'preact'
import Portal from 'preact-portal'

interface Props {
  activeTab?: number
  children?: ComponentChildren[]
  titles: ComponentChildren[]
  style?: { [key: string]: string }
  disableClick?: boolean
  className?: string
  portalIntoClassName?: string
}

interface State {
  activeTab: number
}

export default class Tabs extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      activeTab: props.activeTab ?? 0
    }

    this.showTabHandler = this.showTabHandler.bind(this)
  }

  showTabHandler (index: number, disableClickOnTabs: boolean = false) {
    if (!disableClickOnTabs) {
      this.setState({
        activeTab: index
      })
    }
  }

  render ({ children, titles, style, disableClick, className, portalIntoClassName }: Props, { activeTab }: State) {
    return (
      <div class={`sections__nav ${className ?? ''}`}>
        {portalIntoClassName
          ? <Portal into={`${portalIntoClassName}`}>
            <ul class='tabs--navigation qa-profile-tooltip-tabs' style={style}>
              {titles.map((title: ComponentChildren, index: number) => (
                <li key={index} class='tabs__item qa-tab' onClick={() => this.showTabHandler(index, disableClick)}>
                  <button
                    class={`tabs__btn qa-link-tab ${index === activeTab ? 'tabs__btn--active' : ''}`}
                    type='button'
                  >
                    {title}
                  </button>
                </li>
              ))}
            </ul>
          </Portal>
          : <ul className='tabs--navigation qa-profile-tooltip-tabs' style={style}>
            {titles.map((title: ComponentChildren, index: number) => (
              <li key={index} className='tabs__item qa-tab' onClick={() => this.showTabHandler(index, disableClick)}>
                <button
                  className={`tabs__btn qa-link-tab ${index === activeTab ? 'tabs__btn--active' : ''}`}
                  type='button'
                >
                  {title}
                </button>
              </li>
            ))}
          </ul>}
        <div class='tabs--navigation'>
          {children?.map((child: ComponentChildren, index: number) => (
            <div key={index} class={`tabs qa-tab-content ${index === activeTab ? 'tabs--active' : ''}`}>
              {child}
            </div>
          )) ?? null}
        </div>
      </div>
    )
  }
}
